import { useState } from 'react';
import { Table, TableBody } from '@mui/material';
import { AdviseSupplierLineItem } from '../../../../types/advise';
import { InvoiceLineRow } from './InvoiceLineRow';
import { InvoiceLinesHeader } from './InvoiceLinesHeader';
import { InvoiceLinesPager } from './InvoiceLinesPager';
import { INVOICE_LINES_PER_PAGE, linesOnPage, pageCount } from './InvoiceView.calc';

export interface InvoiceLineItemsTableProps {
  lines: AdviseSupplierLineItem[];
  categories: string[];
  canEdit: boolean;
  onScopeChange: (lineId: string, inScope: boolean) => void;
  onCategoryChange: (lineId: string, category: string) => void;
}

/** An invoice's line items, a page at a time, each with its IN SCOPE checkbox and category. */
export const InvoiceLineItemsTable = ({
  lines,
  categories,
  canEdit,
  onScopeChange,
  onCategoryChange
}: InvoiceLineItemsTableProps) => {
  const [page, setPage] = useState(0);
  const shownPage = Math.min(page, pageCount(lines.length) - 1);
  const shown = linesOnPage(lines, shownPage);

  return (
    <div className="flex flex-col gap-2">
      <Table size="small">
        <InvoiceLinesHeader />
        <TableBody>
          {shown.map((line) => (
            <InvoiceLineRow
              key={line.id}
              line={line}
              categories={categories}
              canEdit={canEdit}
              onScopeChange={(inScope) => onScopeChange(line.id, inScope)}
              onCategoryChange={(category) => onCategoryChange(line.id, category)}
            />
          ))}
        </TableBody>
      </Table>
      {lines.length > INVOICE_LINES_PER_PAGE && (
        <InvoiceLinesPager
          shown={shown.length}
          total={lines.length}
          page={shownPage}
          onPageChange={setPage}
        />
      )}
    </div>
  );
};
